/** Map plan names to number */
const planMapping = {
	free: 0,
	inform: 10,
	deluxe: 20,
	grandfatheredDeluxe: 21,
	engage: 30,
} as const;

export default planMapping;
